export const tagsPermissionsConst = {
  view: {
    value: "view_tag",
    errorMsg: "Użytkownik nie ma uprawnień do odczytu tagu!",
  },
  add: {
    value: "add_tag",
    errorMsg: "Użytkownik nie ma uprawnień do dodania tagu!",
  },
  update: {
    value: "change_tag",
    errorMsg: "Użytkownik nie ma uprawnień do edycji tagu!",
  },
  delete: {
    value: "delete_tag",
    errorMsg: "Użytkownik nie ma uprawnień do usuwania tagu!",
  },
};

// Tracking tags exist only in this panel - the permissions are the ones the
// TrackingTagViewSet checks.
export const trackingTagPermissionsConst = {
  view: {
    value: "view_trackingtag",
    errorMsg: "Użytkownik nie ma uprawnień do odczytu tagów śledzących!",
  },
  add: {
    value: "add_trackingtag",
    errorMsg: "Użytkownik nie ma uprawnień do dodania tagów śledzących!",
  },
  update: {
    value: "change_trackingtag",
    errorMsg: "Użytkownik nie ma uprawnień do edycji tagów śledzących!",
  },
  delete: {
    value: "delete_trackingtag",
    errorMsg: "Użytkownik nie ma uprawnień do usuwania tagów śledzących!",
  },
};
